const { hostname, protocol } = window.location;

const LOCALHOST = "localhost";
const LOCALHOST_STATIC = "127.0.0.1";
const LOCAL_IP_REGEX = /^192\.168\.\d{1,3}\.\d{1,3}$/;

const isHostLocal = (host: string): boolean =>
  host === LOCALHOST || host === LOCALHOST_STATIC || LOCAL_IP_REGEX.test(host);

const isDevSubdomain = (host: string): boolean =>
  host.split(".")?.[0]?.includes("dev");

const isIDP = (host: string): boolean => host.split(".")?.[0]?.includes("idp");

export const isHomologationEnvironment = (str?: string): boolean => {
  let host = str ?? hostname;

  try {
    // Se for uma URL completa (ex: http://192.168.1.17:5173), extrai o hostname
    if (host.includes("http")) {
      const url = new URL(host);
      host = url.hostname;
    }
  } catch (e) {
    console.warn("isHomologationEnvironment: erro ao parsear host:", str, e);
  }

  return isHostLocal(host) || isDevSubdomain(host);
};

const getCookieDomain = () => {
  if (isHostLocal(hostname)) return undefined; // <- omitido nos cookies
  return `.${hostname.replace(/^[\w|-]+\./, "")}`; // ex: ".grupoatem.com.br"
};

const config = {
  api: {
    url: {
      homologation: "https://gateway-dev.grupoatem.com.br",
      production: "https://gateway.grupoatem.com.br",
    },
    urlLocal: "http://localhost:8080",
    timeout: 30000,
  },
  auth: { keys: { token: "@ATEM:grupoAtem:tokenGrupoAtem" } },
  secureTokens: protocol === "https:",
  domain: getCookieDomain(),
  CONFIRMED: "CONFIRMED",
  isIDP: isIDP(hostname),
};

export default config;
